import React from 'react';
import { getOpcStrategyPage } from 'constants/pages';
import Link from 'components/Link';
import { Icon } from '../OptionsProfitCalculator/Icons';

export const StrategyCard: React.FC<
  React.PropsWithChildren<{
    strategy: any;
    ticker: string;
  }>
> = ({ strategy, ticker }) => {
  const marketConditions = strategy.market_conditions.split(', ');
  const { Overview } = strategy?.description;

  return (
    <div className="relative w-full rounded-lg bg-palette-black-4 p-4 shadow-lg">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <Link href={getOpcStrategyPage(strategy.slug, ticker)}>
          <div className="text-xl sm:text-2xl">{strategy?.strategy}</div>
        </Link>
        <div className="flex gap-3">
          {marketConditions.map((condition: string) => {
            const colorClasses: Record<any, any> = {
              Bearish: 'bg-opc-bearish text-white bg-opacity-75',
              Neutral: 'bg-opc-neutral text-text-neutral bg-opacity-90',
              Bullish: 'bg-opc-bullish text-text-bullish',
              Volatile: 'bg-opc-volatile text-text-volatile bg-opacity-90',
              Stable: 'bg-opc-stable text-text-stable bg-opacity-85',
              Income: 'bg-opc-income text-opc-text-income bg-opacity-85',
              Growth: 'bg-opc-growth text-opc-text-growth bg-opacity-85',
              'Very Bearish': 'bg-opc-very-bearish text-white bg-opacity-85',
              'Very Bullish': 'bg-opc-very-bullish text-white bg-opacity-85',
            };

            const colorClass = colorClasses[condition as any] || 'bg-gray-100 text-gray-800';

            return (
              <span
                key={`key-structureLines-${condition}`}
                className={`rounded-full p-1 ${colorClass} flex h-5 w-5 items-center justify-center`}
              >
                <Icon condition={condition} className="w-[16px]" />
              </span>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col md:flex-row">
        <div className="flex-1 gap-4">
          <div className="flex gap-3 py-1">
            <div className="text-lg capitalize text-[#8bb5e9]">{strategy?.skill_level}</div>
            <div className="text-lg opacity-60">{strategy?.subcategory}</div>
          </div>
          <div className="flex py-2">
            <div className="flex flex-wrap items-center gap-2 text-xs text-gray-200">
              <div className="inline-block  rounded-full bg-gray-600 px-3 py-1">
                {strategy?.profit} Profit
              </div>
              <div className="inline-block  rounded-full bg-gray-600 px-3  py-1">
                {strategy?.risk} Risk
              </div>
              <div className="inline-block  rounded-full bg-gray-600 px-3  py-1">
                {strategy?.loss} Loss
              </div>
              <div className="inline-block  rounded-full bg-gray-600 px-3  py-1">
                {strategy?.capital_requirement} Capital Requirement
              </div>
              <div className="inline-block  rounded-full bg-gray-600 px-3  py-1">
                {strategy?.delta_sensitivity} Delta Sensitivity
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-gray-200">
            <div className="inline-block  rounded-full bg-gray-600 px-3 py-1">
              {strategy?.gamma_sensitivity} Gamma Sensitivity
            </div>
            <div className="inline-block  rounded-full bg-gray-600 px-3 py-1">
              {strategy?.theta_sensitivity} Theta Sensitivity
            </div>
            <div className="inline-block  rounded-full bg-gray-600 px-3 py-1">
              {strategy?.vega_sensitivity} Vega Sensitivity
            </div>
            <div className="inline-block  rounded-full bg-gray-600 px-3 py-1">
              {strategy?.theta_impact} Theta Impact
            </div>
          </div>
        </div>
        {/* <div className="right-8 top-0 mr-3 mt-2 sm:absolute">
          <div className="text-dark border-b-gray-400  font-semibold">Structure</div>
          {structureLines.map((line: string, index: number) => (
            <div key={`key-structureLines-${index}`} className="text-sm text-gray-200">
              {line}
            </div>
          ))}
        </div> */}
      </div>
      <div className="mt-4">
        <div>
          <div className="mb-2 text-lg font-semibold text-gray-100">Overview</div>
          <ul>
            {Overview.map((point: string, index: number) => (
              <li key={`key-overview-${index}`} className="ml-6 list-disc text-sm text-gray-200">
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
